import { testCase } from '../app/execute/execute-state'

const maxWorkBreak = 300 // 5 minutes in seconds

let lastTestCaseCode
let lastStart
let lastEnd

export const startWork = () => {
  const now = new Date().valueOf()
  const onTestCase = testCase.value
  const sameTestCase = lastTestCaseCode === testCase.value?.code
  const workBreakWithinLimit = lastStart && now - lastEnd < maxWorkBreak * 1_000
  if (onTestCase && (!sameTestCase || !workBreakWithinLimit)) {
    lastStart = now
    lastTestCaseCode = testCase.value.code
  }
}

export const endWork = () => {
  if (testCase.value && lastStart) {
    lastEnd = new Date().valueOf()
    testCase.value.workDuration = (testCase.value.workDuration || 0) + lastEnd - lastStart
  }
}
